import { checkFileType } from '@/utils/file/checkFileType'

export const isImageByName = (filename: string): boolean => checkFileType(filename, 'image')
